import BookingSuccessModal from './BookingSuccessModal';
export default BookingSuccessModal;